import PaymentNotes from './PaymentNotes';

export default PaymentNotes;
